function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { nl2br } from 'helpers/transformers';
import intlShape from 'shapes/intlShape';
import messages from '../../messages';
import Error from './Error';
var _React_PureComponent;
class GeneralError extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { intl } = this.props;
        const info = intl.formatMessage(messages.errorPage.general.info);
        return /*#__PURE__*/ _jsx(Error, {
            code: this.props.code,
            codeLabel: intl.formatMessage(messages.errorPage.errorCode),
            title: intl.formatMessage(messages.errorPage.general.title),
            info: /*#__PURE__*/ _jsx("p", {
                children: nl2br(info, 'mb-4')
            }),
            buttonLabel: intl.formatMessage(messages.errorPage.goToHomePage)
        });
    }
}
_define_property(GeneralError, "propTypes", {
    code: PropTypes.number,
    intl: intlShape
});
export default injectIntl(GeneralError);
